// extracted by mini-css-extract-plugin
export default {"sm_breadcrumb":"style_sm_breadcrumb__9i4EJ","lg_breadcrumb":"style_lg_breadcrumb__TYJGc","footer":"style_footer__2X3LP"};